/* What the form sends to POST /auth/two-factor-reset — and, as important, what it
 * does not: the password travels at the top level for the server to check and is
 * never part of `details`, which is what an admin will later read. */
export type ResetForm = {
  email: string;
  password: string;
  fullName: string;
  phone: string;
  country: string;
  signupDate: string;
  discord: string;
  notes: string;
};

// the same per-field limits as the server (lib/twoFactorReset.js MEMBER_FIELDS)
export const DETAIL_LIMITS: Record<keyof Omit<ResetForm, 'email' | 'password'>, number> = {
  fullName: 120,
  phone: 40,
  country: 120,
  signupDate: 40,
  discord: 80,
  notes: 1000
};

export const buildResetRequest = (form: ResetForm, captchaToken: string) => {
  const details: Partial<Record<keyof typeof DETAIL_LIMITS, string>> = {};
  for (const key of Object.keys(DETAIL_LIMITS) as Array<keyof typeof DETAIL_LIMITS>) {
    const v = String(form[key] ?? '').trim();
    if (v) details[key] = Array.from(v).slice(0, DETAIL_LIMITS[key]).join('');
  }
  return {
    email: form.email.trim().toLowerCase(),
    password: form.password,
    captchaToken,
    details
  };
};
